export type Scale = SliderScale | ButtonScale | BipolarScale | ImageButtonScale

export const scaleMiddleElementValue = (scale: Scale) =>
  scale.items[Math.floor(scale.items.length / 2)].value

export interface SliderScale {
  items: ReadonlyArray<ScaleItemWithImage>
  isOptimumPoint: boolean
  type: ScaleType.Slider
}

export interface ImageButtonScale {
  items: ReadonlyArray<ScaleItemWithImage>
  type: ScaleType.ImageButtons
}

export interface ButtonScale {
  items: ReadonlyArray<ScaleItemWithoutImage>
  type: ScaleType.Buttons
}

export interface BipolarScale {
  left: ScaleItemWithOptionalImage
  right: ScaleItemWithOptionalImage
  numberOfSteps: number
  items: ReadonlyArray<ScaleItemWithValue>
  type: ScaleType.Bipolar
}

export enum ScaleType {
  Buttons = 'buttons',
  Slider = 'slider',
  Bipolar = 'bipolar',
  ImageButtons = 'image-buttons',
}

export type ScaleItem =
  | ScaleItemWithoutImage
  | ScaleItemWithImage
  | ScaleItemWithValue
  | ScaleItemWithOptionalImage

export interface ScaleItemWithValue {
  value: number
  label?: string
}

interface ScaleItemWithoutImage {
  value: number
  label: string
}

export interface ScaleItemWithImage {
  value: number
  label: string
  image: string
}

interface ScaleItemWithOptionalImage {
  value: number
  label: string
  image?: string
}
